import React, { useEffect, useState } from 'react';
import '../../styles/progresstrack.css';
import { useTranslation } from 'react-i18next';

export default function ProgressTrack({
  currentStep,
  totalSteps = 5,
  onStepClick
}) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);
  const [animating, setAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('forward');
  const [prevStep, setPrevStep] = useState(currentStep);
  const [activeStep, setActiveStep] = useState(currentStep);
  const { t } = useTranslation();
  useEffect(() => {
    if (currentStep !== prevStep) {
      setAnimationDirection(currentStep > prevStep ? 'forward' : 'backward');
      setAnimating(true);

      const timer = setTimeout(() => {
        setAnimating(false);
        setPrevStep(currentStep);
        setActiveStep(currentStep);
      }, 800);

      return () => clearTimeout(timer);
    }
  }, [currentStep, prevStep]);

  const handleStepClick = (step) => {
    onStepClick(step);
  };

  const getLineState = (stepIndex) => {
    const stepNum = stepIndex + 1;

    if (stepNum < activeStep) {
      return 'completed';
    }

    if (stepNum > activeStep) {
      return '';
    }

    if (animating) {
      if (animationDirection === 'forward') {
        if (stepIndex === currentStep - 2) {
          return 'animating-previous';
        }
        if (stepIndex === currentStep - 1) {
          return 'animating-next';
        }
      } else {
        if (stepIndex === currentStep - 2) {
          return 'reverting-previous';
        }
        if (stepIndex === currentStep - 1) {
          return 'clearing-current';
        }
      }
    }

    if (stepNum === activeStep) {
      return 'current';
    }

    return '';
  };

  return (
    <div className="progress-container">
      <div className="progress-track">
        {steps.map((step, index) => (
          <React.Fragment key={step}>
            <div
              className={`step ${step <= activeStep ? 'active' : ''}`}
              onClick={() => handleStepClick(step)}
              style={{
                cursor: step <= activeStep ? 'pointer' : 'default',
                position: 'relative'
              }}
              aria-label={`Go to step ${step}`}
              tabIndex={0}
              onKeyPress={(e) => e.key === 'Enter' && handleStepClick(step)}
            >
              <div className="step-circle">
                {step}
              </div>
              {step <= activeStep && (
                <div className="step-tooltip">
                  {`${t('step')} ${step}`}
                </div>
              )}
            </div>
            {index < totalSteps - 1 && (
              <div
                className={`step-line-wrapper ${getLineState(index)}`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
      <hr className="separator" />
    </div>
  );
}